module.exports = __webpack_public_path__ + "img/layer-plus.104cf38b.svg";